import { makeStyles, tokens } from '@fluentui/react-components';
import { customColors, customFonts } from '../../../../styles';

const useOverviewStyles = makeStyles({
    card: {
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'start',
        width: '100%',
        height: 'auto',
        paddingBlock: '12px 20px', // vertical padding
        paddingInline: '20px', // horizontal padding
        borderRadius: '15px',
        backgroundColor: tokens.colorNeutralBackground1,
        boxShadow: customColors.dropShadow1,
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: customColors.protivitiDarkBlue,
    },
    header: {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: 'fit-content',
        gap: tokens.spacingVerticalXS,
    },
    headerTitle: {
        fontFamily: customFonts.TitleFont,
        fontWeight: tokens.fontWeightSemibold,
        fontSize: '2rem',
        lineHeight: 1,
    },
});

export default useOverviewStyles;
